






import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
    metaInfo() {
        return { title: 'プロモサイト管理' }
    }
})
export default class PromoDashboard extends Vue {
}
